import request from '@/utils/request'

export const getUser = (data: any) => {
  return request<String>('auth/getUser', {
    method: 'POST',
    data,
  })
}
